// import React, { useState, useEffect } from 'react';
// import { FaEye, FaEyeSlash, FaSpinner, FaUserPlus } from 'react-icons/fa';
// import { useNavigate } from 'react-router-dom';
// import api from '../api/apiService';
// import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
// import { auth } from "../utils/firebase";
// import { verifyFirebaseOtp } from '../api/apiService'; // keep only firebase verify import

// // new fix start: Imports for Region Data and Google Maps
// import { REGION_DATA } from '../utils/locationData';
// import { useJsApiLoader, Autocomplete } from "@react-google-maps/api";
// // new fix end

// // new fix start: Libraries constant for Maps
// const libraries = ["places"];
// // new fix end

// function SignUp() {
//   // new fix start: Country State Management
//   // Initialize default country
//   const [selectedCountry, setSelectedCountry] = useState("India");
//   // new fix end

//   const [formData, setFormData] = useState({
//     firstName: '', middleName: '', lastName: '',dob: '', username: '', email: '',
//     password: '', 
//     phone: '', 
//     countryCode: '+91', // new fix start: Added countryCode field // new fix end
//     doorNumber: '', streetName: '',
//     zipCode: '', city: '', state: '', 
//     country: 'India', // new fix start: Default country // new fix end
//   });
//   const [otp, setOtp] = useState('');
//   const [errors, setErrors] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [isSignedUp, setIsSignedUp] = useState(false);
//   const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
//   const [verificationError, setVerificationError] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [otpMethod, setOtpMethod] = useState('mobile');
//   const [phoneOtpSent, setPhoneOtpSent] = useState(false);
//   const [firebaseConfirmation, setFirebaseConfirmation] = useState(null);

//   // separate states for phone/email flows to allow parallel usage
//   const [phoneState, setPhoneState] = useState({ count: 0, loading: false, cooldown: 0 });

//   const MAX_RESEND_ATTEMPTS = 3;
//   const RESEND_COOLDOWN_TIME = 60;
//   const OTP_LENGTH = 6;
//   const navigate = useNavigate();

//   // new fix start: Load Google Maps Script
//   const { isLoaded } = useJsApiLoader({
//     id: 'google-map-script',
//     googleMapsApiKey: process.env.REACT_APP_Maps_API_KEY, // Uses your specific env variable name
//     libraries: libraries,
//   });

//   const [autocompleteRef, setAutocompleteRef] = useState(null);

//   const handleAutocompleteLoad = (ref) => {
//     setAutocompleteRef(ref);
//   };

//   const handlePlaceChanged = () => {
//     if (autocompleteRef) {
//       const place = autocompleteRef.getPlace();
//       if (!place.address_components) return;

//       const getAddressComponent = (compType) => place.address_components.find(c => c.types.includes(compType))?.long_name || "";

//       const city = getAddressComponent("locality") || getAddressComponent("administrative_area_level_2");
//       const stateFromMap = getAddressComponent("administrative_area_level_1");
//       const zip = getAddressComponent("postal_code");
//       const street = place.name || getAddressComponent("route");

//       setFormData(prev => ({
//         ...prev,
//         streetName: street || prev.streetName, // Keep existing if map returns empty
//         city: city || prev.city,
//         zipCode: zip || prev.zipCode,
//         // We try to match state, but user might need to pick from dropdown if names differ slightly
//         state: stateFromMap || prev.state
//       }));
//     }
//   };
//   // new fix end

//   // phone cooldown timer
//   useEffect(() => {
//     let timer;
//     if (phoneState.cooldown > 0) {
//       timer = setInterval(() => setPhoneState(prev => ({ ...prev, cooldown: prev.cooldown - 1 })), 1000);
//     }
//     return () => clearInterval(timer);
//   }, [phoneState.cooldown]);

//   useEffect(() => {
//     let verifier;
//     if (isSignedUp) {
//       try {
//         // Ensure any previous widget DOM is cleared
//         const container = document.getElementById('recaptcha-container');
//         if (container) container.innerHTML = '';

//         verifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
//           size: 'invisible',
//           callback: () => console.log("SignUp reCAPTCHA verified"),
//           'expired-callback': () => setVerificationError("Verification expired. Please try sending the OTP again.")
//         });
//         verifier.render().catch(err => {
//           if (err?.code !== 'auth/internal-error') console.warn("reCAPTCHA render error:", err);
//         });
//         window.recaptchaVerifier = verifier;
//       } catch (e) {
//         console.error("Recaptcha error", e);
//         setVerificationError("Could not initialize verification. Please refresh and try again.");
//       }
//     }

//     return () => {
//       if (verifier) {
//         try {
//           verifier.clear();
//           window.recaptchaVerifier = null;
//         } catch (clearErr) {
//           console.warn("reCAPTCHA cleanup error:", clearErr);
//         }
//       }
//     };
//   }, [isSignedUp]);

//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     setFormData({ ...formData, [id]: value });
//     setErrors({ ...errors, [id]: undefined, apiError: undefined });
//   };

//   // new fix start: Handle Country Change logic
//   const handleCountryChange = (e) => {
//     const newCountry = e.target.value;
//     const regionInfo = REGION_DATA[newCountry];
    
//     setSelectedCountry(newCountry);
//     setFormData(prev => ({
//         ...prev,
//         country: newCountry,
//         countryCode: regionInfo.code, // Auto-update phone code
//         state: '' // Reset state as lists differ
//     }));
//   };
//   // new fix end

//   const handleOtpChange = (e) => {
//     const value = e.target.value.replace(/\D/g, '');
//     if (value.length <= OTP_LENGTH) setOtp(value);
//     setVerificationError('');
//   };

//   const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

//   const validateSignup = () => {
//     const tempErrors = {};
//     if (!formData.firstName.trim()) tempErrors.firstName = 'First name is required';
//     if (!formData.lastName.trim()) tempErrors.lastName = 'Last name is required';
//     if (!formData.username.trim()) tempErrors.username = 'Username is required';
//     if (!formData.email.trim()) tempErrors.email = 'Email is required';
//     else if (!validateEmail(formData.email)) tempErrors.email = 'Please enter a valid email address';
//     if (!formData.phone.trim()) tempErrors.phone = 'Phone number is required';
//     if (!formData.state) tempErrors.state = 'State is required'; // new fix start: added state validation // new fix end

//     const password = formData.password;
//     if (!password) tempErrors.password = 'Password is required';
//     else {
//       if (password.length < 8) tempErrors.password = 'Password must be at least 8 characters';
//       else if (!/[A-Z]/.test(password)) tempErrors.password = 'Must include an uppercase letter';
//       else if (!/[a-z]/.test(password)) tempErrors.password = 'Must include a lowercase letter';
//       else if (!/[0-9]/.test(password)) tempErrors.password = 'Must include a number';
//       else if (!/[!@#$%^&*]/.test(password)) tempErrors.password = 'Must include a special character (!@#$%^&*)';
//     }
//     setErrors(tempErrors);
//     return Object.keys(tempErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateSignup()) return;
//     setLoading(true);
//     try {
//       const userPayload = { ...formData };
//       const response = await api.post('/auth/signup', userPayload);
//       // backend may respond with isVerifying flag for abandoned signup
//       if (response.data?.isVerifying) {
//         setVerificationError('Account already exists but is not verified. Please complete verification.');
//       } else {
//         setVerificationError('');
//       }
//       setIsSignedUp(true); // show verification UI in both cases
//     } catch (error) {
//       const errorMessage = error.response?.data?.error || 'Something went wrong during signup.';
//       setErrors({ ...errors, apiError: errorMessage });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // phone OTP using firebase, uses phoneState
//   const handleSendPhoneOtp = async () => {
//     if (phoneState.cooldown > 0 || phoneState.count >= MAX_RESEND_ATTEMPTS) return;
//     setPhoneState(prev => ({ ...prev, loading: true, count: prev.count + 1 }));
//     setVerificationError('');
//     try {
//       const appVerifier = window.recaptchaVerifier;
//       // new fix start: Use dynamic country code
//       const phoneNumber = `${formData.countryCode}${formData.phone}`; 
//       // new fix end
      
//       const confirmation = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
//       setFirebaseConfirmation(confirmation);
//       setPhoneOtpSent(true);
//       setPhoneState(prev => ({ ...prev, cooldown: RESEND_COOLDOWN_TIME }));
//     } catch (error) {
//       setVerificationError(error.message || 'Failed to send OTP. Please try again.');
//       if (window.recaptchaVerifier) {
//         window.recaptchaVerifier.render().then(widgetId => { if (window.grecaptcha) window.grecaptcha.reset(widgetId); });
//       }
//     } finally {
//       setPhoneState(prev => ({ ...prev, loading: false }));
//     }
//   };

//   const handleVerifyPhoneOtp = async () => {
//     if (!firebaseConfirmation || otp.length !== OTP_LENGTH) {
//       setVerificationError(`Please enter a valid ${OTP_LENGTH}-digit OTP`);
//       return;
//     }
//     setIsVerifyingOtp(true);
//     setVerificationError('');
//     try {
//       const result = await firebaseConfirmation.confirm(otp);
//       const user = result.user;
//       const firebaseToken = await user.getIdToken();
//       await verifyFirebaseOtp({ firebaseToken });
//       navigate('/login', { state: { message: "Account verified successfully! Please log in." } });
//     } catch (error) {
//       const errorMessage = error.response?.data?.error || error.message || 'Failed to verify OTP.';
//       setVerificationError(errorMessage);
//     } finally {
//       setIsVerifyingOtp(false);
//     }
//   };

//   const handleStartOver = () => {
//     setIsSignedUp(false);
//     setOtp('');
//     setErrors({});
//     setPhoneState({ count: 0, loading: false, cooldown: 0 });
//     setVerificationError('');
//     setPhoneOtpSent(false);
//     // new fix start: Reset region data
//     setFormData({
//       firstName: '', middleName: '', lastName: '', username: '', email: '',
//       password: '', phone: '', countryCode: '+91', doorNumber: '', streetName: '',
//       zipCode: '', city: '', state: '', country: 'India',
//     });
//     setSelectedCountry("India");
//     // new fix end
//   };

//   if (!isLoaded) return <div className="text-center p-5">Loading Maps...</div>; // new fix start: Loading state for maps // new fix end

//   // verification UI (unchanged markup but email-related UI commented out)
//   if (isSignedUp) {
//     return (
//       <div className="d-flex justify-content-center align-items-center bg-light" style={{ minHeight: '100vh' }}>
//         <div className="card shadow-lg animate__animated animate__fadeIn" style={cardStyle}>
//           <div className="card-body p-4">
//             <h3 className="card-title text-center mb-4" style={headingStyle}>Verify Your Account</h3>

//             <div className="mb-3 text-center">
//               <button className={`btn btn-sm me-2 ${otpMethod === 'mobile' ? 'btn-primary' : 'btn-outline-primary'}`} onClick={() => setOtpMethod('mobile')}>Mobile OTP</button>
//             </div>

//             {verificationError && (<small className="text-danger d-block text-center mb-3">{verificationError}</small>)}

//             {otpMethod === 'mobile' && (
//               <>
//                 {!phoneOtpSent ? (
//                   <>
//                     <p className="text-center text-muted mb-4" style={descriptionStyle}>Click the button below to receive an OTP on your mobile.</p>
//                     <button className="btn btn-primary w-100 mb-3" style={primaryButtonStyle} onClick={handleSendPhoneOtp} disabled={phoneState.loading}>
//                       {phoneState.loading ? <FaSpinner className="fa-spin" /> : 'Send OTP to Mobile'}
//                     </button>
//                   </>
//                 ) : (
//                   <>
//                     {/* new fix start: Show correct country code */}
//                     <p className="text-center text-muted mb-4" style={descriptionStyle}>Please enter the OTP sent to <strong style={{ color: '#007bff' }}>{formData.countryCode} {formData.phone}</strong>.</p>
//                     {/* new fix end */}
//                     <div className="mb-3">
//                       <label htmlFor="otp" className="form-label" style={labelStyle}>OTP</label>
//                       <input type="text" id="otp" className="form-control text-center" placeholder={`Enter ${OTP_LENGTH}-digit OTP`} value={otp} onChange={handleOtpChange} maxLength={OTP_LENGTH} style={inputStyle} />
//                     </div>
//                     <button className="btn btn-primary w-100 mb-3" style={primaryButtonStyle} onClick={handleVerifyPhoneOtp} disabled={isVerifyingOtp || otp.length !== OTP_LENGTH}>
//                       {isVerifyingOtp ? <FaSpinner className="fa-spin" /> : 'Verify & Complete Signup'}
//                     </button>
//                     <div className="d-flex justify-content-center align-items-center mt-3">
//                       {phoneState.cooldown > 0 ? (
//                         <p className="text-muted small mb-0">Resend OTP in {phoneState.cooldown}s</p>
//                       ) : (
//                         <button type="button" className="btn btn-link text-decoration-none p-0" style={{ color: '#007bff', fontSize: '0.9rem' }} onClick={handleSendPhoneOtp} disabled={phoneState.loading || phoneState.count >= MAX_RESEND_ATTEMPTS}>
//                           {phoneState.loading ? <FaSpinner className="fa-spin" /> : 'Resend OTP'}
//                         </button>
//                       )}
//                     </div>
//                     {phoneState.count >= MAX_RESEND_ATTEMPTS && (<p className="text-warning small mt-2 text-center">Too many resend attempts. Please <button type="button" className="btn btn-link p-0 text-decoration-none" onClick={handleStartOver} style={{ color: '#007bff' }}>start over</button>.</p>)}
//                   </>
//                 )}
//                 <div id="recaptcha-container"></div>
//               </>
//             )}

//           </div>
//         </div>
//       </div>
//     );
//   }

//   // --- SIGN UP FORM VIEW ---
//   return (
//     <div className="d-flex justify-content-center align-items-center bg-light" style={{ minHeight: '100vh' }}>
//       <div className="card shadow-lg animate__animated animate__fadeIn" style={cardStyle}>
//         <div className="card-body p-4">
//           <div className="text-center mb-4">
//             <div style={iconContainerStyle}><FaUserPlus size={24} color="#007bff" /></div>
//             <h3 className="card-title mt-3" style={headingStyle}>Create Account</h3>
//             <p className="text-muted" style={descriptionStyle}>Sign up for a new account</p>
//           </div>
//           <form onSubmit={handleSubmit}>
//             {/* new fix start: Added Mandatory Asterisks to Labels */}
//            <FormInput id="firstName" label={<span>First Name <span className="text-danger">*</span></span>} placeholder="Enter first name" value={formData.firstName} onChange={handleChange} error={errors.firstName} />
//             <FormInput id="middleName" label="Middle Name (optional)" placeholder="Enter middle name" value={formData.middleName} onChange={handleChange} />
//             <FormInput id="lastName" label={<span>Last Name <span className="text-danger">*</span></span>} placeholder="Enter last name" value={formData.lastName} onChange={handleChange} error={errors.lastName} />
            
//             {/* ✅ NEW: Optional Date of Birth Field */}
//             <div className="mb-3">
//               <label htmlFor="dob" className="form-label" style={labelStyle}>Date of Birth (Optional)</label>
//               <input 
//                 type="date" 
//                 id="dob" 
//                 className="form-control" 
//                 value={formData.dob} 
//                 onChange={handleChange} 
//                 max={new Date().toISOString().split("T")[0]} 
//                 style={inputStyle} 
//               />
//             </div>

//             <FormInput id="username" label={<span>Username <span className="text-danger">*</span></span>} placeholder="Choose a username" value={formData.username} onChange={handleChange} error={errors.username} />

//             <FormInput id="email" type="email" label={<span>Email Address <span className="text-danger">*</span></span>} placeholder="Enter email address" value={formData.email} onChange={handleChange} error={errors.email} />
//             {/* new fix end */}
            
//             <div className="mb-3 position-relative">
//               {/* new fix start: Added Star */}
//               <label htmlFor="password" className="form-label" style={labelStyle}>Password <span className="text-danger">*</span></label>
//               {/* new fix end */}
//               <div className="input-group">
//                 <input type={showPassword ? 'text' : 'password'} id="password" className={`form-control ${errors.password ? 'is-invalid' : ''}`} placeholder="Create a strong password" value={formData.password} onChange={handleChange} aria-describedby="password-error" style={inputStyle} />
//                 <button type="button" className="btn btn-outline-secondary" onClick={() => setShowPassword(!showPassword)} style={eyeButtonStyle} aria-label={showPassword ? 'Hide password' : 'Show password'}>
//                   {showPassword ? <FaEye size={18} /> : <FaEyeSlash size={18} />}
//                 </button>
//               </div>
//               {errors.password && (<small id="password-error" className="text-danger">{errors.password}</small>)}
//             </div>

//             {/* new fix start: Country Selection Dropdown with UI enhancements */}
//             <div className="mb-3">
//                 <label className="form-label" style={labelStyle}>Country <span className="text-danger">*</span></label>
//                 <select 
//                     className="form-select" // Used form-select for dropdown arrow
//                     value={selectedCountry} 
//                     onChange={handleCountryChange} 
//                     style={inputStyle} 
//                 >
//                     {Object.keys(REGION_DATA).map(country => (
//                         <option key={country} value={country}>{country}</option>
//                     ))}
//                 </select>
//             </div>
//             {/* new fix end */}

//             {/* new fix start: Phone Input with Auto-Updated Country Code */}
//             <div className="mb-3">
//                 <label htmlFor="phone" className="form-label" style={labelStyle}>Phone Number <span className="text-danger">*</span></label>
//                 <div className="input-group">
//                     <span className="input-group-text" style={{backgroundColor: '#e9ecef', border: '1px solid #dee2e6'}}>{formData.countryCode}</span>
//                     <input type="text" id="phone" className={`form-control ${errors.phone ? 'is-invalid' : ''}`} placeholder="Enter phone number" value={formData.phone} onChange={handleChange} style={inputStyle} />
//                 </div>
//                 {errors.phone && (<small className="text-danger">{errors.phone}</small>)}
//             </div>
//             {/* new fix end */}

//             {/* new fix start: Added Star */}
//             <FormInput id="doorNumber" label={<span>Door Number <span className="text-danger">*</span></span>} placeholder="Enter door/flat number" value={formData.doorNumber} onChange={handleChange} />
//             {/* new fix end */}
            
//             {/* new fix start: Autocomplete for Street Name with Star */}
//             <div className="mb-3">
//                 <label htmlFor="streetName" className="form-label" style={labelStyle}>Street Name <span className="text-danger">*</span></label>
//                 <Autocomplete
//                     onLoad={handleAutocompleteLoad}
//                     onPlaceChanged={handlePlaceChanged}
//                     options={{ 
//                         types: ['address'], 
//                         componentRestrictions: { country: REGION_DATA[selectedCountry].iso } // Restrict to selected country
//                     }}
//                 >
//                     <input 
//                         type="text" 
//                         id="streetName" 
//                         className={`form-control`} 
//                         placeholder={`Search address in ${selectedCountry}`} 
//                         value={formData.streetName} 
//                         onChange={handleChange} 
//                         style={inputStyle} 
//                     />
//                 </Autocomplete>
//             </div>
//             {/* new fix end */}

//             {/* new fix start: Added Star */}
//             <FormInput id="zipCode" label={<span>Zip Code <span className="text-danger">*</span></span>} placeholder="Enter zip code" value={formData.zipCode} onChange={handleChange} />
//             {/* new fix end */}
            
//             <div className="row">
//                 <div className="col-6">
//                     {/* new fix start: Added Star */}
//                     <FormInput id="city" label={<span>City <span className="text-danger">*</span></span>} placeholder="Enter city" value={formData.city} onChange={handleChange} />
//                     {/* new fix end */}
//                 </div>
//                 <div className="col-6">
//                     {/* new fix start: State Dropdown with UI enhancements */}
//                     <div className="mb-3">
//                         <label htmlFor="state" className="form-label" style={labelStyle}>State <span className="text-danger">*</span></label>
//                         <select 
//                             id="state" 
//                             className={`form-select ${errors.state ? 'is-invalid' : ''}`} // Used form-select
//                             value={formData.state} 
//                             onChange={handleChange} 
//                             style={inputStyle}
//                         >
//                             <option value="">Select State</option>
//                             {REGION_DATA[selectedCountry].states.map(state => (
//                                 <option key={state} value={state}>{state}</option>
//                             ))}
//                         </select>
//                         {errors.state && (<small className="text-danger">{errors.state}</small>)}
//                     </div>
//                     {/* new fix end */}
//                 </div>
//             </div>

//             {/* new fix start: REMOVED Bottom Country Input */}
//             {/* The disabled country input that was here is now deleted as requested */}
//             {/* new fix end */}

//             <button type="submit" className="btn btn-primary w-100 mt-3" style={primaryButtonStyle} disabled={loading}>
//               {loading ? <FaSpinner className="fa-spin" /> : 'Sign Up'}
//             </button>
//           </form>
//           {errors.apiError && (<small className="text-danger text-center d-block mt-3">{errors.apiError}</small>)}
//           <div className="text-center mt-4 text-muted" style={{ fontSize: '0.9rem' }}>
//             Already have an account?{' '}
//             <a href="/login" className="text-decoration-none" style={{ color: '#007bff' }}>Login here</a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// const FormInput = ({ id, label, placeholder, value, onChange, error, type = 'text' }) => (
//   <div className="mb-3">
//     <label htmlFor={id} className="form-label" style={labelStyle}>{label}</label>
//     <input type={type} id={id} className={`form-control ${error ? 'is-invalid' : ''}`} placeholder={placeholder} value={value} onChange={onChange} aria-describedby={error ? `${id}-error` : undefined} style={inputStyle} />
//     {error && (<small id={`${id}-error`} className="text-danger">{error}</small>)}
//   </div>
// );

// const cardStyle = { width: '24rem', borderRadius: '1rem', background: '#ffffff', border: '1px solid #e0e0e0', boxShadow: '0 8px 20px rgba(0, 0, 0, 0.08)', color: '#333333', animationDuration: '0.5s' };
// const headingStyle = { fontWeight: '600', fontSize: '1.8rem', color: '#333333', marginBottom: '0.5rem' };
// const descriptionStyle = { fontSize: '0.95rem', color: '#6c757d' };
// const iconContainerStyle = { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#e9f5ff', borderRadius: '50%', padding: '0.8rem', border: '1px solid #cce5ff', width: '50px', height: '50px', marginBottom: '1rem' };
// const labelStyle = { color: '#495057', fontSize: '0.9rem', fontWeight: '500' };
// const inputStyle = { borderRadius: '0.4rem', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', color: '#343a40', fontSize: '1rem', padding: '0.75rem 1rem', boxShadow: 'inset 0 1px 2px rgba(0, 0, 0, 0.04)', transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out' };
// const primaryButtonStyle = { borderRadius: '0.5rem', padding: '0.8rem 1.5rem', fontWeight: 'bold', fontSize: '1.05rem', backgroundColor: '#007bff', border: 'none', boxShadow: '0 4px 10px rgba(0, 123, 255, 0.2)', cursor: 'pointer', transition: 'background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out, transform 0.1s ease' };
// const secondaryButtonStyle = { borderRadius: '0.5rem', padding: '0.8rem 1.5rem', fontWeight: 'bold', fontSize: '1.05rem', backgroundColor: '#6c757d', border: 'none', boxShadow: '0 4px 10px rgba(108, 117, 125, 0.1)', cursor: 'pointer', transition: 'background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out, transform 0.1s ease' };
// const eyeButtonStyle = { borderTopLeftRadius: '0', borderBottomLeftRadius: '0', borderColor: '#dee2e6', backgroundColor: '#e9ecef', color: '#6c757d', transition: 'background-color 0.2s ease-in-out, border-color 0.2s ease-in-out' };

// export default SignUp;
import React, { useState, useEffect } from 'react';
import { FaEye, FaEyeSlash, FaSpinner, FaUserPlus } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import api from '../api/apiService'; 
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../utils/firebase";
// import '../styles/signup.css';

// Imports for Region Data and Google Maps
import { REGION_DATA } from '../utils/locationData';
import { useJsApiLoader } from "@react-google-maps/api";

const libraries = ["places"];

function SignUp() {
  const [selectedCountry, setSelectedCountry] = useState("India");

  const [formData, setFormData] = useState({
    firstName: '', 
    middleName: '', 
    lastName: '', 
    username: '', 
    email: '',
    password: '', 
    phone: '', 
    countryCode: '+91', 
    doorNumber: '', 
    streetName: '',
    zipCode: '', 
    city: '', 
    state: '', 
    country: 'India', 
  });

  const [otp, setOtp] = useState('');
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [isSignedUp, setIsSignedUp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [verificationError, setVerificationError] = useState('');
  const [loading, setLoading] = useState(false);
  const [phoneOtpSent, setPhoneOtpSent] = useState(false);
  const [firebaseConfirmation, setFirebaseConfirmation] = useState(null);

  const [phoneState, setPhoneState] = useState({ count: 0, loading: false, cooldown: 0 });

  const MAX_RESEND_ATTEMPTS = 3;
  const RESEND_COOLDOWN_TIME = 60;
  const OTP_LENGTH = 6;
  const navigate = useNavigate();

  // Load Google Maps Script
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_Maps_API_KEY, 
    libraries: libraries,
  });

  const [autocompleteRef, setAutocompleteRef] = useState(null);

  // Note: Autocomplete wrapper removed due to deprecation
  // User can now manually enter street name without suggestions

  // Phone cooldown timer
  useEffect(() => {
    let timer;
    if (phoneState.cooldown > 0) {
      timer = setInterval(() => setPhoneState(prev => ({ ...prev, cooldown: prev.cooldown - 1 })), 1000);
    }
    return () => clearInterval(timer);
  }, [phoneState.cooldown]);

  // Recaptcha initialization
  useEffect(() => {
    if (isSignedUp && !window.recaptchaVerifier) {
      try {
        window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
          size: 'invisible',
          callback: () => console.log("reCAPTCHA verified"),
        });
      } catch (e) {
        console.error("Recaptcha error", e);
        setVerificationError("Verification system failed to load.");
      }
    }
    return () => { 
        if (window.recaptchaVerifier) {
            window.recaptchaVerifier.clear();
            window.recaptchaVerifier = null;
        }
    };
  }, [isSignedUp]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
    setErrors({ ...errors, [id]: undefined, apiError: undefined });
  };

  const handleCountryChange = (e) => {
    const newCountry = e.target.value;
    const regionInfo = REGION_DATA[newCountry];
    setSelectedCountry(newCountry);
    setFormData(prev => ({
        ...prev,
        country: newCountry,
        countryCode: regionInfo.code,
        state: '' 
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    const cleanPhone = formData.phone.trim().replace(/\D/g, '').slice(-10);
    const submissionData = { ...formData, phone: cleanPhone };

    try {
      const response = await api.post('/auth/signup', submissionData);
      if (response.data.success) {
        setIsSignedUp(true);
      }
    } catch (error) {
      setErrors({ apiError: error.response?.data?.error || 'Signup failed.' });
    } finally {
      setLoading(false);
    }
  };

  const handleSendPhoneOtp = async () => {
    if (phoneState.cooldown > 0) return;
    setPhoneState(prev => ({ ...prev, loading: true }));
    setVerificationError('');

    try {
      const appVerifier = window.recaptchaVerifier;
      const fullPhoneNumber = `${formData.countryCode}${formData.phone.trim()}`;
      const confirmation = await signInWithPhoneNumber(auth, fullPhoneNumber, appVerifier);
      setFirebaseConfirmation(confirmation);
      setPhoneOtpSent(true);
      setPhoneState(prev => ({ ...prev, cooldown: RESEND_COOLDOWN_TIME }));
    } catch (error) {
      console.error("Firebase SMS Error:", error);
      setVerificationError('Failed to send SMS. Please check the number.');
    } finally {
      setPhoneState(prev => ({ ...prev, loading: false }));
    }
  };

  const handleVerifyPhoneOtp = async () => {
    if (!firebaseConfirmation || otp.length !== OTP_LENGTH) return;
    setIsVerifyingOtp(true);
    setVerificationError('');

    try {
      const result = await firebaseConfirmation.confirm(otp);
      const firebaseToken = await result.user.getIdToken();
      const response = await api.post('/auth/verify-firebase', { firebaseToken });

      if (response.data.success) {
        navigate('/login', { state: { message: "Verified! You can now login." } });
      }
    } catch (error) {
      console.error("Verification Error:", error);
      setVerificationError(error.response?.data?.error || 'Invalid OTP code.');
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  if (!isLoaded) return <div className="text-center p-5">Loading Maps...</div>;

  if (isSignedUp) {
    return (
      <div className="d-flex justify-content-center align-items-center bg-light" style={{ minHeight: '100vh' }}>
        <div className="card shadow-lg p-4" style={cardStyle}>
          <div className="card-body">
            <h3 className="text-center mb-4" style={headingStyle}>Verify Phone</h3>
            {verificationError && <div className="alert alert-danger py-2 small">{verificationError}</div>}
            
            {!phoneOtpSent ? (
              <button className="btn btn-primary w-100" onClick={handleSendPhoneOtp} disabled={phoneState.loading}>
                {phoneState.loading ? <FaSpinner className="fa-spin" /> : 'Send OTP via SMS'}
              </button>
            ) : (
              <>
                <p className="text-center text-muted small">Code sent to <b>{formData.countryCode} {formData.phone}</b></p>
                <input type="text" className="form-control text-center mb-3" placeholder="Enter 6-digit code" value={otp} onChange={(e) => setOtp(e.target.value.replace(/\D/g, ''))} maxLength={6} style={inputStyle} />
                <button className="btn btn-primary w-100" onClick={handleVerifyPhoneOtp} disabled={isVerifyingOtp || otp.length < 6}>
                  {isVerifyingOtp ? <FaSpinner className="fa-spin" /> : 'Verify & Activate'}
                </button>
                <div className="text-center mt-3">
                  {phoneState.cooldown > 0 ? (
                    <span className="text-muted small">Resend in {phoneState.cooldown}s</span>
                  ) : (
                    <button className="btn btn-link btn-sm" onClick={handleSendPhoneOtp}>Resend Code</button>
                  )}
                </div>
              </>
            )}
            <div id="recaptcha-container"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center bg-light py-5" style={{ minHeight: '100vh' }}>
      <div className="card shadow-lg" style={cardStyle}>
        <div className="card-body p-4">
          <div className="text-center mb-4">
            <div style={iconContainerStyle}><FaUserPlus size={24} color="#007bff" /></div>
            <h3 style={headingStyle}>Create Account</h3>
          </div>
          
          <form onSubmit={handleSubmit}>
            <FormInput id="firstName" label="First Name *" value={formData.firstName} onChange={handleChange} error={errors.firstName} />
            <FormInput id="middleName" label="Middle Name (Optional)" value={formData.middleName} onChange={handleChange} />
            <FormInput id="lastName" label="Last Name *" value={formData.lastName} onChange={handleChange} error={errors.lastName} />
            <FormInput id="username" label="Username *" value={formData.username} onChange={handleChange} error={errors.username} />
            <FormInput id="email" label="Email *" type="email" value={formData.email} onChange={handleChange} error={errors.email} />
            
            <div className="mb-3">
              <label className="form-label" style={labelStyle}>Password *</label>
              <div className="input-group">
                <input type={showPassword ? 'text' : 'password'} id="password" className={`form-control ${errors.password ? 'is-invalid' : ''}`} value={formData.password} onChange={handleChange} style={inputStyle} />
                <button type="button" className="btn btn-outline-secondary" onClick={() => setShowPassword(!showPassword)} style={eyeButtonStyle}>
                  {showPassword ? <FaEye /> : <FaEyeSlash />}
                </button>
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label" style={labelStyle}>Country *</label>
              <select className="form-select" value={selectedCountry} onChange={handleCountryChange} style={inputStyle}>
                {Object.keys(REGION_DATA).map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label" style={labelStyle}>Phone Number *</label>
              <div className="input-group">
                <span className="input-group-text">{formData.countryCode}</span>
                <input type="text" id="phone" className="form-control" value={formData.phone} onChange={handleChange} style={inputStyle} />
              </div>
            </div>

            <FormInput id="doorNumber" label="Door / Flat Number *" value={formData.doorNumber} onChange={handleChange} />

            <div className="mb-3">
              <label className="form-label" style={labelStyle}>Street Name *</label>
              <input type="text" id="streetName" className="form-control" value={formData.streetName} onChange={handleChange} style={inputStyle} />
            </div>

            <FormInput id="zipCode" label="Zip Code *" value={formData.zipCode} onChange={handleChange} />

            <div className="row">
              <div className="col-6">
                <FormInput id="city" label="City *" value={formData.city} onChange={handleChange} />
              </div>
              <div className="col-6">
                <label className="form-label" style={labelStyle}>State *</label>
                <select id="state" className="form-select" value={formData.state} onChange={handleChange} style={inputStyle}>
                  <option value="">Select State</option>
                  {REGION_DATA[selectedCountry].states.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
            </div>

            <button type="submit" className="btn btn-primary w-100 mt-4 py-2" style={primaryButtonStyle} disabled={loading}>
              {loading ? <FaSpinner className="fa-spin" /> : 'Sign Up'}
            </button>
          </form>
          {errors.apiError && <div className="text-danger text-center mt-3 small">{errors.apiError}</div>}
        </div>
      </div>
    </div>
  );
}

const FormInput = ({ id, label, value, onChange, error, type = 'text' }) => (
  <div className="mb-3">
    <label htmlFor={id} className="form-label" style={labelStyle}>{label}</label>
    <input type={type} id={id} className={`form-control ${error ? 'is-invalid' : ''}`} value={value} onChange={onChange} style={inputStyle} />
    {error && <small className="text-danger">{error}</small>}
  </div>
);

const cardStyle = { width: '100%', maxWidth: '480px', borderRadius: '1rem', background: '#fff', boxShadow: '0 8px 20px rgba(0,0,0,0.08)' };
const headingStyle = { fontWeight: '700', color: '#2d3436' };
const iconContainerStyle = { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#e9f5ff', borderRadius: '50%', width: '55px', height: '55px', marginBottom: '10px' };
const labelStyle = { fontSize: '0.85rem', fontWeight: '600' };
const inputStyle = { backgroundColor: '#f8f9fa', borderRadius: '8px' };
const primaryButtonStyle = { fontWeight: '600', borderRadius: '8px' };
const eyeButtonStyle = { borderLeft: 'none', backgroundColor: '#f8f9fa' };

export default SignUp;
